import { useLocation } from 'react-router-dom';

function Navbar() {
  // const phrases = ['Web Development', 'Mobile Apps'];
  // const [displayText, setDisplayText] = useState('');
  // const [phraseIndex, setPhraseIndex] = useState(0);
  // const [charIndex, setCharIndex] = useState(0);
  const routeLocation = useLocation();

  // useEffect(() => {
  //   const currentPhrase = phrases[phraseIndex];
  //   let timeout;

  //   if (charIndex < currentPhrase.length) {
  //     timeout = setTimeout(() => {
  //       setDisplayText((prev) => prev + currentPhrase[charIndex]);
  //       setCharIndex((prev) => prev + 1);
  //     }, 100);
  //   } else {
  //     // Pause before starting next word
  //     timeout = setTimeout(() => {
  //       setDisplayText('');
  //       setCharIndex(0);
  //       setPhraseIndex((prev) => (prev + 1) % phrases.length);
  //     }, 1000);
  //   }

  //   return () => clearTimeout(timeout);
  // }, [charIndex, phraseIndex]);

  
  const styles = {
    header: {
      position: 'relative',
      height: routeLocation.pathname === '/' ? '100vh' : 'auto',
      overflow: 'hidden',
      fontFamily: "'Open Sans', sans-serif",
      backgroundColor: routeLocation.pathname !== '/' ? '#000' : 'transparent',
    },
    navbar: {
      position: routeLocation.pathname === '/' ? 'absolute' : 'relative',
      top: 0,
      width: '100%',
      padding: '20px 50px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      zIndex: 2,
    },
    logo: {
      fontWeight: 'bold',
      fontSize: '28px',
      color: 'white',
    },
    navLinks: {
      display: 'flex',
      gap: '20px',
      listStyle: 'none',
    },
    link: {
      color: 'white',
      textDecoration: 'none',
    },
    activeLink: {
      color: '#00bfff',
      textDecoration: 'none',
    },
    heroSection: {
      position: 'relative',
      width: '100%',
      height: '100vh',
    },
    heroBg: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      position: 'absolute',
      filter: 'brightness(0.3)',
      top: 0,
      left: 0,
      zIndex: 1,
    },
    heroContent: {
      position: 'relative',
      zIndex: 3,
      textAlign: 'center',
      color: 'white',
      top: '50%',
      transform: 'translateY(-50%)',
      padding: '0 20px',
    },
    welcomeHeading: {
      fontSize: '50px',
      fontWeight: 'bold',
      margin: '10px 0',
      color: 'white',
    },
    animatedText: {
      fontSize: '20px',
      color: 'white',
      margin: '20px 0',
    },
    highlight: {
      color: '#00bfff',
      borderBottom: '2px solid #00bfff',
    },
    ctaButtons: {
      marginTop: '20px',
      display: 'flex',
      justifyContent: 'center',
      gap: '20px',
    },
    btnPrimary: {
      backgroundColor: '#00bfff',
      color: 'white',
      padding: '12px 30px',
      fontSize: '16px',
      textDecoration: 'none',
      borderRadius: '3px',
    },
    btnOutline: {
      border: '2px solid #00bfff',
      padding: '10px 28px',
      color: 'white',
      textDecoration: 'none',
      fontSize: '16px',
      borderRadius: '3px',
    },
  };

  return (
    <header style={styles.header}>
      <nav style={styles.navbar}>
  <img 
    src="/assets/img/logo3.png" 
    alt="Almac Logo" 
    style={{ height: '100px', width: 'auto' }} 
  />
  <ul style={styles.navLinks}>
    <li><a href="#hero" style={styles.activeLink}>Home</a></li>
    <li><a href="#about" style={styles.link}>About</a></li>
    <li><a href="#services" style={styles.link}>Services</a></li>
    <li><a href="#portfolio" style={styles.link}>Portfolio</a></li>
    <li><a href="#team" style={styles.link}>Team</a></li>
    <li><a href="#contact" style={styles.link}>Contact</a></li>
  </ul>
</nav>

      {routeLocation.pathname === '/' && (         
        <section style={styles.heroSection}>
          <video
                autoPlay
                muted
                loop
                playsInline
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  position: 'absolute',
                  filter: 'brightness(0.85)', //  just the right balance
                  top: 0,
                  left: 0,
                  zIndex: 1,
                }}>
                <source src={`${process.env.PUBLIC_URL}/assets/video/hero-animation2.mp4`} type="video/mp4" />
            </video>


          <div style={styles.heroContent}>
            {/* <img src="/assets/img/logo.png" className="img-fluid mb-3" alt="Imperial Logo" /> */}
           <h1 style={styles.welcomeHeading}>
              <span style={{ fontSize: '45px', fontWeight: '400' }}>Welcome to </span>
              <strong style={{ fontSize: '55px', fontWeight: '800', fontFamily: 'Georgia, serif' }}>
                Almac Company
              </strong>
            </h1>

             <p style={{ fontSize: '18px', color: '#' }}>
                Your Reliable Partner in International and Local Trade
             </p>

            {/* <p style={styles.animatedText}>
              We create <span style={styles.highlight}>{displayText}</span>
            </p> */}
            <div style={styles.ctaButtons}>
              {/* <a href="#about" style={styles.btnPrimary}>Get Started</a> */}
              <a href="#services" style={styles.btnOutline}>Our Services</a>
            </div>
          </div>
        </section>
      )}
    </header>
  );
}

export default Navbar;
                   